import red from "@material-ui/core/colors/red";
import { createMuiTheme } from "@material-ui/core/styles";
import createBreakPoints from "@material-ui/core/styles/createBreakpoints";

const breakpoints = createBreakPoints({});
const spacingUnit = 4;

const theme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      main: "#fcb71e",
    },
    secondary: red,
  },
  spacing: {
    unit: spacingUnit,
  },
  mixins: {
    toolbar: {
      "@media (min-width:0px) and (orientation: landscape)": {
        minHeight: 65,
      },
      "@media (min-width:600px)": {
        minHeight: 65,
      },
    },
  },
  typography: {
    // In Japanese the characters are usually larger.
    fontSize: 14,
    useNextVariants: true,
    [breakpoints.down("md")]: {
      fontSize: 12,
    },
    color: "#263238",
  },
  props: {
    MuiButtonBase: {
      disableRipple: true, // No more ripple, on the whole application 💣!
    },
  },
  overrides: {
    MuiListItem: {
      gutters: {
        [breakpoints.down("xs")]: {
          padding: spacingUnit * 2,
        },
      },
    },
    MuiListItemIcon: {
      root: {
        [breakpoints.down("xs")]: {
          marginRight: spacingUnit,
        },
        color: "#263238 !important",
      },
    },

    MuiTypography: {
      root: {
        [breakpoints.down("xs")]: {
          fontSize: "16px !important",
        },
        [breakpoints.down("sm")]: {
          fontSize: "14px !important",
        },
        color: "#263238",
      },
    },

    MuiFab: {
      root: {
        [breakpoints.down("xs")]: {
          width: "48px !important",
          height: "48px !important",
        },
        color: "#fff !important",
      },
      sizeSmall: {
        [breakpoints.down("xs")]: {
          width: "36px !important",
          height: "36px !important",
        },
      },
    },

    MuiButton: {
      containedPrimary: {
        color: "#fff !important",
      },
    },

    //Table

    MuiTableRow: {
      root: {
        [breakpoints.down("xs")]: {
          height: 32,
        },
        borderBottom: "1px solid #eeeeee",
      },
    },
    MuiTableCell: {
      root: {
        padding: `${spacingUnit}px ${spacingUnit}px ${spacingUnit}px ${
          spacingUnit * 6
        }px`,
        [breakpoints.down("xs")]: {
          padding: `${spacingUnit}px ${spacingUnit}px ${spacingUnit}px ${
            spacingUnit * 2
          }px`,
        },
      },
      head: {
        color: "#263238 !important",
        fontWeight: 500,
        lineHeight: 1.5,
        fontSize: 14,
      },
      body: {
        color: "#263238 !important",
      },
    },

    MuiTableHead: {
      root: {
        backgroundColor: "#fafafa",
      },
    },

    // MuiToolbar:{
    //     root:{
    //         backgroundColor: '#fafafa'
    //     }
    // },

    MuiTablePagination: {
      caption: {
        [breakpoints.down("sm")]: {
          fontSize: "12px !important",
        },
      },
      actions: {
        [breakpoints.down("sm")]: {
          marginLeft: "0px !important",
        },
      },
    },

    MuiPaper: {
      elevation2: {
        boxShadow:
          "0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)",
        // boxShadow: 'none'
      },
      elevation4: {
        // boxShadow: 'none'
        boxShadow:
          "0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)",
      },
    },
    MuiIcon: {
      root: {
        [breakpoints.down("sm")]: {
          fontSize: "20px !important",
        },
      },
    },
    MuiIconButton: {
      root: {
        [breakpoints.down("sm")]: {
          padding: "8px !important",
        },
      },
    },
  },
});

export default theme;
